import React from 'react';

import { observer, inject } from 'mobx-react';
import PropTypes from 'prop-types';
import { withNamespaces, Trans } from 'react-i18next';

import { TextAreaField } from 'libs/forms/views/fieldTypes/textArea';
import { EditorField } from 'libs/forms/views/fieldTypes/editor';
import { FileField } from 'libs/forms/views/fieldTypes/file';
import { HeaderMarginTop as Main } from 'legacyComponents/styled/lib';
import DocumentHead from 'legacyComponents/documentHead';

import { conf as globalConf } from 'apps/config.yaml';

import { NewStoryAppManager } from 'apps/story/newStory/appManager';
import {
  StoryWrapper,
  TitleInput,
  BodyInput,
  CoverImageCropper,
  BannerStyled,
  CenterWrapper,
} from 'apps/story/styles';
import { PublishStory } from 'apps/story/views/publishStory';

import { Cropper } from 'apps/components/cropper';
import Button from 'components/Button';

import Header from 'apps/components/header/header';
import { modalStore } from 'apps/modals/app';
import { CommunityGuidelinesModal } from 'apps/modals/communityGuidelines';

const { siteName } = globalConf;

@inject('clientStore', 'routerStore')
@withNamespaces()
@observer
export class NewStory extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showGuidelinesBanner: true,
    };
    const { clientStore, routerStore } = props;
    if (clientStore && clientStore.signedInProfile) {
      this.appManager = new NewStoryAppManager(null, {});
    } else {
      routerStore.navigate('home.signIn', { next: clientStore.next() });
    }
  }

  onClickPublish = () => {
    const { storyApp } = this.appManager;
    const { storyForm } = storyApp;
    if (storyForm.isValid) {
      modalStore.SetModalComponent(PublishStory, { storyApp });
    } else {
      storyForm.alert();
    }
  };

  onClickGuidelines = e => {
    e.preventDefault();
    modalStore.SetModalComponent(CommunityGuidelinesModal);
  };

  render() {
    const { t } = this.props;
    if (!this.appManager) {
      return null;
    }
    const { storyApp } = this.appManager;
    const actions = [
      <Button
        text={<Trans>Publish</Trans>}
        key='publishAction'
        onClick={this.onClickPublish}
        icon='arrow_right'
        iconPosition='right'
      />,
    ];
    return (
      <Main>
        <Header actions={actions} noNav />
        <DocumentHead title={`${t('New Story')} | ${siteName}`} />
        {this.state.showGuidelinesBanner && (
          <BannerStyled
            variant='info'
            isDismissable={() => this.setState({ showGuidelinesBanner: false })}
          >
            <Trans>
              Want to write great stories? Check our tips on{' '}
              <strong>
                <a
                  href='/+wikifactory/stories/10-tips-to-write-great-stories-on-wikifactory'
                  target='_blank'
                  rel='noopener noreferrer'
                >
                  How to write stories
                </a>
              </strong>{' '}
              and our{' '}
              <strong>
                <a onClick={this.onClickGuidelines} href='#'>
                  Community Guidelines
                </a>
              </strong>{' '}
              story.
            </Trans>
          </BannerStyled>
        )}
        <FileField
          fieldStore={storyApp.storyForm.fieldStores.get('avatar')}
          previewComponent={Cropper}
          editComponent={CoverImageCropper}
        />
        <StoryWrapper>
          <TextAreaField
            fieldStore={storyApp.storyForm.fieldStores.get('title')}
            editComponent={TitleInput}
            validationPosition={{ top: '14px', right: '0px' }}
          />
          <EditorField
            fieldStore={storyApp.storyForm.fieldStores.get('body')}
            editComponent={BodyInput}
            noValidationIcon
            noFormattingHint
          />
          <CenterWrapper>{actions}</CenterWrapper>
        </StoryWrapper>
      </Main>
    );
  }
}

NewStory.propTypes = {
  clientStore: PropTypes.object,
  routerStore: PropTypes.object,
  t: PropTypes.func,
};
